<template lang="pug">
  chapter-button(v-if="chapterButtons" class="chapter-button" type="next" :disabled="nextChapterDisabled" :color="color" @click="dispatch" data-test="chapter-next")
</template>

<script>
import { mapState } from 'redux-vuex';

import select from '@/store/selectors';
import { PlayButton, ChapterButton, StepperButton } from '@/components/shared-components';
import store from '@/store';

export default {
  components: {
    PlayButton,
    ChapterButton,
    StepperButton,
  },
  data: mapState({
    nextChapterDisabled: select.components.nextChapterDisabled,
    chapterButtons: select.components.chapterButtons,
    color: select.theme.brandLightest,
  }),
  methods: {
    dispatch: store.dispatch,
  },
};
</script>
<styles lang="postcss" scoped>
</styles>
